import { VimGraphQLClient } from '@getvim/gql-client';

class GraphQlClient {
  private gqlClient: VimGraphQLClient;

  constructor(baseUri: string = '/prior-auth/api/graphql') {
    this.gqlClient = new VimGraphQLClient(baseUri);
  }

  public getClient(): VimGraphQLClient {
    return this.gqlClient;
  }

  public setAccessToken(accessToken: string): void {
    this.gqlClient.setAccessToken(accessToken);
  }
}

export const graphQlClient = new GraphQlClient();
